export enum ApplicationType {
    HomeExtension= 'HOME_EXTENSION',
    Dormer = 'DORMER',
    Frame = 'FRAME',
}
